import { React, useState, useEffect } from 'react'
import '../../layouts/stylesheets/loader-style.css'
import { AiTwotoneSnippets } from 'react-icons/ai'

const CampaignDetails = (props) => {
  const [campaignDetails, setCampaignDetails] = useState({
    name: props.oldCampaignData ? props.oldCampaignData.campaignName : '',
    budget: props.oldCampaignData ? props.oldCampaignData.campaignBudget : '',
    conversionValue: props.oldCampaignData
      ? props.oldCampaignData.conversionValue
      : '',
  })
  const [formErrors, setFormErrors] = useState({ errors: {} })

  useEffect(() => {
    const handleNav = (props) => {
      props.setNav('')
      if (props.nav === 'forward') {
        let errors = {}
        let proceed = true
        if (campaignDetails.name.length < 3) {
          errors.name = 'Please enter a campaign name.'
          proceed = false
        }
        if (campaignDetails.budget.length < 1) {
          errors.budget = 'Please enter a campaign budget.'
          proceed = false
        }
        if (campaignDetails.conversionValue.length < 1) {
          errors.conversionValue = 'Please enter a conversion value.'
          proceed = false
        }
        if (!proceed) {
          setFormErrors({ ...formErrors, errors })
          return
        }
        props.setCampaignData({
          ...props.campaignData,
          campaignName: campaignDetails.name,
          campaignBudget: campaignDetails.budget,
          conversionValue: campaignDetails.conversionValue,
        })
        props.setActivePage('campaignDestination')
      } else if (props.nav === 'back') {
        props.setActivePage('campaignObjective')
      }
    }
    handleNav(props)
  }, [
    campaignDetails.budget,
    campaignDetails.conversionValue,
    campaignDetails.name,
    formErrors,
    props,
  ])

  const handleChange = (event) => {
    setCampaignDetails({
      ...campaignDetails,
      [event.target.id]: event.target.value,
    })
  }
  const rowClass =
    'grid w-full grid-cols-1 gap-2 md:grid-cols-[minmax(12rem,42%)_minmax(16rem,1fr)] md:gap-0'
  const labelClass =
    'flex h-12 items-center justify-center rounded-full bg-[#F7FAF7] px-5 text-center text-base font-unbounded text-gray-900 shadow-sm md:h-14 md:text-[17px] xl:h-16 xl:text-lg'
  const inputWrapClass = 'relative min-w-0 md:-ml-10'
  const inputClass =
    'h-12 w-full rounded-full border-0 bg-[#DEE6DD] px-6 text-base text-gray-900 placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-[#C9D7C2] md:h-14 md:px-8 md:pl-12 md:text-[17px] xl:h-16 xl:text-lg'
  const dollarClass =
    'pointer-events-none absolute left-5 top-1/2 -translate-y-1/2 text-base md:left-7 md:text-[17px] xl:text-lg'

  return (
    <div className="w-full max-w-[72rem] px-4 sm:px-6">
      {/* Top breadcrumb-ish title */}
      <div className="flex items-center gap-2 mb-4">
        <AiTwotoneSnippets />

        <p className="font-unbounded uppercase tracking-wide">
          {props.pageType === 'edit' ? 'Update' : 'Add'} Campaign Details
        </p>
      </div>

      {/* Main Heading + Subcopy */}
      <h3 className="text-2xl font-unbounded mb-4">
        Set up your M-Link
      </h3>
      <p className="leading-snug text-lg text-[#0b0b0b]/80 mb-10 max-w-[58rem] xl:mb-14">
        {
          'Enter key details for your campaign. These values help identify your campaign across M‑Link and M‑Sight.'
        }
      </p>

      {/* Row: Campaign Name */}
      <div className={`${rowClass} mb-5 xl:mb-6`}>
        <span className={labelClass}>
          Campaign Name
        </span>
        <div className={inputWrapClass}>
          <input
            id="name"
            className={inputClass}
            placeholder="Brand Awareness"
            required
            value={campaignDetails.name}
            onChange={handleChange}
          />
        </div>
      </div>
      {formErrors.errors.name ? (
        <p className="text-[#f44] font-bold text-center mb-4">
          {formErrors.errors.name}
        </p>
      ) : (
        ''
      )}

      {/* Row: Campaign Budget */}
      <div className={`${rowClass} mb-5 xl:mb-6`}>
        <span className={labelClass}>
          Campaign Budget
        </span>
        <div className={inputWrapClass}>
          <span
            className={
              dollarClass +
              ' ' +
              (campaignDetails.budget ? 'text-gray-900' : 'text-gray-500')
            }
          >
            $
          </span>
          <input
            id="budget"
            className={inputClass}
            placeholder="7,500.00"
            required
            value={campaignDetails.budget}
            type="number"
            pattern="[0-9]*"
            inputMode="numeric"
            onChange={handleChange}
          />
        </div>
      </div>
      {formErrors.errors.budget ? (
        <p className="text-[#f44] font-bold text-center mb-4">
          {formErrors.errors.budget}
        </p>
      ) : (
        ''
      )}

      {/* Row: Conversion Value */}
      <div className={rowClass}>
        <span className={labelClass}>
          Conversion Value
        </span>
        <div className={inputWrapClass}>
          <span
            className={
              dollarClass +
              ' ' +
              (campaignDetails.conversionValue
                ? 'text-gray-900'
                : 'text-gray-500')
            }
          >
            $
          </span>
          <input
            id="conversionValue"
            className={inputClass}
            placeholder="5.00"
            required
            value={campaignDetails.conversionValue}
            type="number"
            pattern="[0-9]*"
            inputMode="numeric"
            onChange={handleChange}
          />
        </div>
      </div>
      {formErrors.errors.conversionValue ? (
        <p className="text-[#f44] font-bold text-center mt-4">
          {formErrors.errors.conversionValue}
        </p>
      ) : (
        ''
      )}
    </div>
  )
}

export default CampaignDetails
